export default {
  //是否为空
  isNullOrEmpty: function (value) {
    return value === null || value === "" || value === undefined ? true : false;
  },

  //是否为手机号
  isMobile: function (value) {
    return /^(?:13\d|14\d|15\d|16\d|17\d|18\d|19\d)\d{5}(\d{3}|\*{3})$/.test(
      value
    );
  },
  //台湾
  isXg: function (value) {
    return /^[0][9]\d{8}$/.test(
      value
    );
  },
  //台湾带国际号
  isXggjh: function (value) {
    return /^(\+?00886\-?|0)?9\d{8}$/.test(
      value
    );
  },
  //是否包含座机地址
  isLandline: function (value) {
    return /0\d{2,3}-\d{7,8}|\(?0\d{2,3}[)-]?\d{7,8}|\(?0\d{2,3}[)-]*\d{7,8}/.test(
      value
    );
  },
  //金额，只允许保留两位小数
  isFloat: function (value) {
    return /^([0-9]*[.]?[0-9])[0-9]{0,1}$/.test(value);
  },
  //是否全为数字
  isNum: function (value) {
    return /^[0-9]+$/.test(value);
  },
  //是否包含中文字符
  isCharacter: function (value) {
    return /[\u4e00-\u9fa5]/.test(value);
  },
  //是否包含Url地址
  isUrl: function (value) {
    return /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/.test(value);
  },
  //是否包含空白行
  isUrl: function (value) {
    return /\s/.test(value);
  },
  //是否包含Email地址
  isEmail: function (value) {
    return /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/.test(value);
  },
  //去空格
  trim: function (value) {
    return value.replace(/(^\s*)|(\s*$)/g, "");
  },
  //密码为8~20位数字和字母组合
  checkPwd: function (value) {
    return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(value);
  },
  //   ^w+$
  checkPwdly: function (value) {
    return /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[])+$)([^(0-9a-zA-Z)]|[]|[a-zA-Z]|[0-9]){6,}$/.test(
      value
    );
  },
  //格式手机号码
  formatNum: function (num) {
    if (regextool.isMobile(num)) {
      num = num.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
    }
    return num;
  },
  //国际手机号或座机号校验
  isXggjh: function(value) {
    // return /^([+]?0?\d{2,3}-?|\([+]?0?\d{2,3}\)|\([+]?0?\d{2,3}\))?\d+$|^([+]?0?\d{2,3}-?|\([+]?0?\d{2,3}\)|\([+]?0?\d{2,3}\))?[1-9]\d{4,10}(-\d{1,10})?$/.test(value)
    return /[1][3-8]\d{9}$|([6|9])\d{7}$|[0][9]\d{8}$|6\d{5}$/.test(value)

  },
  //是否为香港手机号
  isXg: function(value) {
    return /^[0][9]\d{8}$/.test(value);
  }
};



// WEBPACK FOOTER //
// ./src/utils/util.js